import type { App } from 'vue';
import UUID from 'uuidjs';

export default {
  install(app: App<Element>, urlObj: any = {}) {
    // 生成uuid的方法(识别分享)
    app.config.globalProperties.$uuid = () => UUID.generate();

    urlObj.corpId = urlObj.corpId || urlObj.corpid;

    // 案例逻辑加强
    if (urlObj.materialType === 'case') {
      urlObj.materialType = 'article';
      urlObj.scene = '2001';
    }

    // 网销获客新增参数 👇👇👇👇👇👇👇👇👇👇👇👇👇👇
    // "deliverType":"来源类型（staffShare员工分享 publicLaunch公域投放 advertising广告投放）",
    // "sourceId":"来源ID（员工uid,  共域投放：来源ID（自定义），广告投放：url）(链接带参)",
    // urlObj.deliverType = urlObj.deliverType || 'staffShare';
    if (urlObj.qwUid && !urlObj.deliverType) urlObj.deliverType = 'staffShare';

    urlObj.view = urlObj.view?.includes('yes') ? 'yes' : '';
    app.config.globalProperties.$urlObj = urlObj;

    // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓当素材通过小程序访问时，会动态在H5链接上拼接isQwMp（企微）或isWxMp（个微）↓↓↓↓↓↓↓↓↓↓
    // 是否为【企业微信】的小程序环境访问，小程序跳转进来的（预览状态），不会上报
    const isQwMp = String(urlObj.isQwMp) === 'true';
    app.config.globalProperties.$isQwMp = isQwMp;

    // 是否为企微小程序并且为员工
    const isQwStaff = String(urlObj.isQwStaff) === 'true';
    app.config.globalProperties.$isQwStaff = isQwStaff;

    // 是否为【微信】的小程序环境访问，小程序跳转进来的（非预览状态），会上报，并且将会更改上报参数platform的值，改为【MINI】
    const isWxMp = String(urlObj.isWxMp) === 'true';
    app.config.globalProperties.$isWxMp = isWxMp;
    // ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑当素材通过小程序访问时，会动态在H5链接上拼接isQwMp（企微）或isWxMp（个微）↑↑↑↑↑↑↑↑↑↑↑

    // 是否为小程序：【微信小程序】||【企微小程序】
    /**
     * 企微小程序、微信小程序内嵌C端时，对应的相同、不同点如下
     * 1、相同点：
     *   1. 顶部显示小程序名片栏，支持跳转到小程序
     * 2、不同点
     *   1. 微信小程序要走C端自己的授权登录、上报
     *   2. 企微小程序不走C端自己的授权登录、上报，一种纯预览的状态
     */
    const isMp = isQwMp || isWxMp;
    app.config.globalProperties.$isMp = isMp;

    // 是否为wx浏览器环境：微信会进行授权的，正常的微信用户访问
    const isWx = /micromessenger/i.test(navigator.userAgent);
    app.config.globalProperties.$isWx = isWx;

    // 是否为企业微信浏览器环境：企业微信不会进行授权的，企业微信跳转进来的（预览状态）
    // 判断是否是企微环境时，加上$isQwMp，有时navigator.userAgent 没有 wxwork
    const isQw = /wxwork/i.test(navigator.userAgent); // || true;
    app.config.globalProperties.$isQw = isQw || isQwMp;

    // 是否为移动端设备访问
    const isMobile = /(iPhone|iPod|iPad|Android|ios|SymbianOS|Mobile)/i.test(navigator.userAgent);
    app.config.globalProperties.$isMobile = isMobile;
    // app.config.globalProperties.$isMobile = isMobile || urlObj.isMobile === 'true';

    // 是否为Ios设备访问
    const isIOS = /(iPhone|iPod|iPad|ios)/i.test(navigator.userAgent);
    app.config.globalProperties.$isIOS = isIOS;

    // 是否为windows环境
    const isWindows = /windows|win32|win64/i.test(navigator.userAgent);
    app.config.globalProperties.$isWindows = isWindows;

    // 进入页面时生成的时间：先拿链接上面的operTime，其次自己生成
    app.config.globalProperties.$enterPageTime = urlObj.operTime ? Number(urlObj.operTime) : new Date().getTime();

    // 当前资料类型
    const { materialType } = urlObj;
    app.config.globalProperties.$materialType = materialType;

    // 线索实体，值的来源：从链接上面 || 'material'（必传参数）- v3上报所需
    // 用户行为对应的实体,material/miniMaterial/commonMaterial/card/phone/address/wxNo
    const operateEntity = urlObj.operateEntity || 'material';
    app.config.globalProperties.$operateEntity = operateEntity;

    // 当前资料类型对应的id值，从地址栏上面拿的
    const materialId = urlObj.materialId || urlObj.artId || urlObj.formId;
    app.config.globalProperties.$materialId = materialId;

    // 生成activityId-每次上报时都统一使用，进入页面后只生成一次
    // 2020-04-02 10:50更改，当为小程序访问时，需要从地址栏上面拿activityId，目的是当小程序分享时，能实现模拟C端的分享
    // 2020-10-14 activityId的值：先拿地址栏的activityId，再拿自己生成的
    const activityId = urlObj.activityId || app.config.globalProperties.$uuid();
    // const activityId = app.config.globalProperties.$uuid();
    app.config.globalProperties.$activityId = activityId;

    /**
     * 是否为预览状态
     * 链接上有view=yes场景：服务商后台素材预览，官方模板，不会做任何上报
     * 1. 企微工作台，侧边栏，只会记录分享，不会记录pv、uv
     * 2. 预览提示只会再iframe嵌套时显示，且是在服务商后台素材预览时（iframeData === 'yes'）, 同时不会做任何上报
     * 特殊说明：微信小程序访问时不能处理为预览，因为处理为预览后，顶部会有预览文案，这个要去掉；其次就不会走上报了，需求是需要上报的
     */
    const isView = urlObj.view === 'yes' || urlObj.accountName === 'chenfeng' || urlObj.iframeData === 'yes';
    app.config.globalProperties.$isView = isView || window.location.href.includes('#/music');

    // 是否开启debug模式
    const isDebug = urlObj.debug === 'yes';
    app.config.globalProperties.$isDebug = isDebug;

    // 是否为企微端侧边栏
    const isSideMenu = String(urlObj.isSideMenu) === 'true' || String(urlObj.showGoBackBtn) === 'true';
    app.config.globalProperties.$isSideMenu = isSideMenu;

    // 是否使用父级的wx对象
    const wxVector = String(urlObj.wxVector) === 'true';
    app.config.globalProperties.$wxVector = wxVector;

    // 是否显示分享按钮：目前工作手机、企微端时会显示
    const showShare = String(urlObj.showShare) === 'true';
    app.config.globalProperties.$showShare = showShare;

    /**
     * 是否显示分享按钮
     * 1. 不是侧边栏
     * 2. 不是小程序
     * 3. 手机
     * 4. 企微环境
     */
    const isShareBtn = !isSideMenu && !isMp && isMobile && isQw && showShare;
    app.config.globalProperties.$isShareBtn = isShareBtn;

    /**
     * 判断是否需要注册分享信息
     * 1. 不是侧边栏
     * 2. 不是小程序
     * 3. 手机
     * 3. 微信环境（企微/个微）
     */
    const isShare = !isSideMenu && !isMp && (isQw || isWx);
    app.config.globalProperties.$isShare = isShare;

    /**
     * 是否显示发送按钮
     * 1. 移动端
     * 2. 侧边栏
     */
    app.config.globalProperties.$isSendBtn = isSideMenu && isQw && isMobile && !isMp;

    /**
     * 当前C端项目是否是从qw场景出来的：服务商后端、SCRM都属于qw
     *  1. 使用 createH5Url 方法生成C端的地址上面必定会有project=qw字段，所以可以用project来判断是否为 qw
     *  2. 但以前老的，没有使用 createH5Url 方法生成C端的地址上面没有project字段，所以要兼容以前 qw老链接，就可以用 corpId 字段来判断是否为 qw
     */
    const sourceQw = urlObj.project === 'qw' || urlObj.corpId;
    app.config.globalProperties.$sourceQw = sourceQw;

    /**
    * 当前C端项目是否是从cof场景出来的：目前只有朋友圈助手属于qw
    *  1. 使用 createH5Url 方法生成C端的地址上面必定会有project=cof字段，所以可以用project来判断是否为 cof
    *  2. 当为朋友圈助手出来的链接必定会有project=cof，因为它是使用 createH5Url 方法生成链接的，朋友圈助手是不允许私自生成C端url的
    */
    const sourceCof = urlObj.project === 'cof';
    app.config.globalProperties.$sourceCof = sourceCof;

    /**
     * 当前C端项目是否是从mk场景出来的：营销中心、工作手机都属于mk
     *  1. 使用 createH5Url 方法生成C端的地址上面必定会有project=mk字段，所以可以用project来判断是否为 mk
     *  2. 但以前老的，没有使用 createH5Url 方法生成C端的地址上面没有project字段，所以要兼容以前 mk老链接，就可以用这个逻辑判断：首先不为qw，其次不为cof，最后就为mk
     */
    let sourceMk = false;
    if (sourceQw) sourceMk = false;
    else if (sourceCof) sourceMk = false;
    else sourceMk = true;
    app.config.globalProperties.$sourceMk = sourceMk;

    // 是否为【第三方应用】来源
    const sourceThird = urlObj.projectSecondScene === 'third';
    app.config.globalProperties.$sourceThird = sourceThird;

    // 是否为【名片小程序】来源
    const sourceCardMini = urlObj.sourcePlatform?.includes('CardMini');
    app.config.globalProperties.$sourceCardMini = sourceCardMini;

    // 来源是否为[微官网]
    app.config.globalProperties.$sourceMicroSite = urlObj.sourceFrom?.includes('MicroSite');

    // 来源是否为[自动朋友圈]
    app.config.globalProperties.$sourceAutoFriend = urlObj.sourceFrom === 'autoFriend';
    /**
     * 是否手动关闭微信授权
     * !预览状态必定关闭授权，具体哪些是预览状态，请看上面 isView 的判断
     * !当不为预览时，则必定要走授权，除非手动关闭
     */
    let isCloseWxAuth = isView || isQwMp || !isWx;
    // 当地址上面有closeWxAuth===yes时，需要重新更改isCloseWxAuth的值，设置为true，不走微信网页授权
    if (urlObj.closeWxAuth === 'yes') isCloseWxAuth = true;
    app.config.globalProperties.$isCloseWxAuth = isCloseWxAuth;

    /**
     * 是否关闭上报：
     *  1. false：不关闭，表明项目需要上报的
     *  2. true：关闭，表明项目不需要上报的
     *  !预览时必定不上报
     *  !当不为预览时，则必定要走上报，除非手动关闭
     */
    let isNoReport = isView || isQw || isQwMp;
    // 当地址上面有noReport===yes时，需要重新更改isNoReport的值，设置为true，不要走上报
    if (urlObj.noReport === 'yes') isNoReport = true;
    app.config.globalProperties.$isNoReport = isNoReport;

    app.config.globalProperties.$appType = urlObj.appType || 'H5';

    // pageIds为经过base64转码后的url(不包含参数)
    const pageIds = [];
    const pageIdItem = window.btoa(window.location.href.split('?')[0]);
    pageIds.push(pageIdItem);
    app.config.globalProperties.$pageIds = pageIds;

    const parentMaterialId = urlObj.parentMaterialId || '';
    app.config.globalProperties.$parentMaterialId = parentMaterialId;
  }
};
